import usageBilling from '@attunewise/shared/usage-billing'

const add = (x, y, debug) => {
  return op(x, y, (x, y) => x + y, debug)
}

const sub = (x, y, debug) => {
  return op(x, y, (x, y) => x - y, debug)
}

const op  = (x, y, f, debug) => {
  if (!y) {
    y = {}
  }
  if (!x) {
    x = {}
  }
  const z = {}
  for (const id in x) {
    if (!y[id]) {
      y[id] = {}
    }
    for (const model in x[id]) {
      if (!y[id][model]) {
        y[id][model] = 0
      }
    }
  }
  for (const id in y) {
    if (!x[id]) {
      x[id] = {}
    }
    for (const model in y[id]) {
      if (!x[id][model]) {
        x[id][model] = 0
      }
    }
  }
  for (const id in x) {
    if (!z[id]) {
      z[id] = {}
    }
    for (const model in x[id]) {
      z[id][model] = f((y[id][model] || 0),(x[id][model] || 0))
    }
  }
  return z
}

const tallyUsage = ({resolvePrice, events}) => {

  if (!events) {
    return { byToolCallId: {}, totalUsage: {} }
  }

  let PRICES = {}
  let TOTAL = {}
  
  const applyUsage = x => {
    const inTokens = {}
    const outTokens = {}
    const cachedTokens = {}
    const cacheWriteTokens = {}
    const inDollars = {}
    const outDollars = {}
    const cacheReadDollars = {}
    const cacheWriteDollars = {}
    for (const model in x.usage) {
      const usage = x.usage[model]
      if (usage && usage.inputTokens) {
        const PRICE = resolvePrice(model, usage)
        PRICES[model] = PRICE
        const cost = usageBilling.usageCostBreakdown(usage, PRICE)
        const inputTokens = cost.uncachedInputTokens
        const outputTokens = cost.outputTokens
        const cacheReadTokens = cost.cacheReadTokens
        const cacheWriteTokenCount = cost.cacheWriteTokens
        const i$ = cost.uncachedInputDollars + cost.cacheReadDollars + cost.cacheWriteDollars
        const o$ = cost.outputDollars
        if (!inTokens[model]) {
          inTokens[model] = 0
        }
        if (!cachedTokens[model]) {
          cachedTokens[model] = 0
        }
        if (!cacheWriteTokens[model]) {
          cacheWriteTokens[model] = 0
        }
        if (!outTokens[model]) {
          outTokens[model] = 0
        }
        if (cacheReadTokens) {
          cachedTokens[model] += cacheReadTokens
        }
        if (cacheWriteTokenCount) {
          cacheWriteTokens[model] += cacheWriteTokenCount
        }
        if (!inDollars[model]) {
          inDollars[model] = 0
        }
        if (!outDollars[model]) {
          outDollars[model] = 0
        }
        inDollars[model] += i$
        outDollars[model] += o$
        inTokens[model] += inputTokens
        outTokens[model] += outputTokens
        cacheReadDollars[model] = cachedTokens[model] * PRICE.cached
        cacheWriteDollars[model] = cacheWriteTokens[model] * PRICE.cacheWrite        
      }
    }
    return {
      inTokens,
      outTokens,
      cachedTokens,
      cacheWriteTokens,
      inDollars,
      outDollars,
      cacheReadDollars,
      cacheWriteDollars
    }
  }

  const print = (total) => {
    const { inTokens, outTokens, cachedTokens, cacheWriteTokens, inDollars, outDollars, cacheReadDollars, cacheWriteCollars } = total
    if (inTokens) {
      let count = 0
      let dollars = 0
      for (const model in inTokens) {
        const PRICE = PRICES[model]
        dollars += inDollars[model] + outDollars[model] 
        count++
        if (false) console.log({
          model,
          inTokens: inTokens[model],
          outTokens: outTokens[model],
          cachedTokens: cachedTokens[model],
          cacheWriteTokens: cacheWriteTokens[model],
          inDollars: inDollars[model],
          outDollars: outDollars[model],
          cacheReadDollars,
          cacheWriteDollars
        })
      }
      //console.log("TOTAL DOLLARS", dollars)
    } else {
      //console.log("NO DATA")
    }
  }

  let byToolCallId = {}
  let running = {}
  let last
  for (const x of events) {
    const { message, usage } = x
    if (usage) {
      const r = applyUsage(x)
      running = add(running, r)
      if (last && last.tool_call_id) {
        byToolCallId[last.tool_call_id] = r
      }
    }
    last = message
  }
  return { byToolCallId, totalUsage: running }
  
}

const tallyTranscriptUsage = ({messages, model, resolvePrice}) => {
  let total = {}
  for (const event of messages || []) {
    if (!event || !event.message || event.message.role !== 'assistant') continue
    if (model && event.model !== model) continue
    const { totalUsage } = tallyUsage({ resolvePrice, events: [event] })
    total = add(totalUsage, total)
  }
  return { usage: total }
}

export { tallyUsage, add, sub, tallyTranscriptUsage }
